<template>
  <div class="rank" :class="`rank-${tier}`" :title="titleByTier[tier]" />
</template>

<script>
  const titleByTier = { 41: 'Elite', 42: 'Grandmaster', 43: 'High Warlord', 44: 'Legend' }
  const tierNames = ['Explorer', 'Artisan', 'Scout', 'Hunter', 'Tactician', 'Sentinel', 'Vindicator', 'Architect']
  const romans = [' V', ' I', ' II', ' III', ' IV']
  for (let index = 0; index < 41; index++) {
    titleByTier[index] = tierNames[Math.round((index - 3) / 5)] + romans[(index % 10) % 5]
  }

  export default {
    name: 'LeaderbordRank',
    props: {
      tier: {
        type: Number,
      },
    },
    data() {
      return { titleByTier }
    },
  }
</script>

<style lang="postcss">
  .rank {
    width: 30px;
    height: 30px;
    background-image: url('../assets/ranks_sprite_50.png');
    background-size: 30px;
    background-repeat: no-repeat;
  }

  @for $i from 0 to 45 {
    .rank-$i {
      /* prettier-ignore */
      background-position: 0 calc(-30 * $(i)px - 1px);
      background-repeat: no-repeat;
    }
  }
  /*   
  .rank-45 {
    background-position: 0 -2px;
  }
  .rank-44 {
    background-position: 0 -32px;
  }
  .rank-43 {
    background-position: 0 -62px;
  }
  .rank-42 {
    background-position: 0 -92px;
  }
  .rank-41 {
    background-position: 0 -122px;
  }

  .rank-40 {
    background-position: 0 -152px;
  }
  .rank-39 {
    background-position: 0 -182px;
  }
  .rank-38 {
    background-position: 0 -212px;
  }
  .rank-37 {
    background-position: 0 -242px;
  }
  .rank-36 {
    background-position: 0 -272px;
  }
  .rank-35 {
    background-position: 0 -302px;
  }
  .rank-34 {
    background-position: 0 -332px;
  }
  .rank-33 {
    background-position: 0 -362px;
  }
  .rank-32 {
    background-position: 0 -392px;
  }
  .rank-31 {
    background-position: 0 -422px;
  }
  .rank-30 {
    background-position: 0 -452px;
  }
  .rank-29 {
    background-position: 0 -482px;
  }
  .rank-28 {
    background-position: 0 -512px;
  }
  .rank-27 {
    background-position: 0 -542px;
  }
  .rank-26 {
    background-position: 0 -572px;
  }
  .rank-25 {
    background-position: 0 -602px;
  }
  .rank-24 {
    background-position: 0 -632px;
  }
  .rank-23 {
    background-position: 0 -662px;
  }
  .rank-22 {
    background-position: 0 -692px;
  }
  .rank-21 {
    background-position: 0 -722px;
  } */
</style>
